import { render, staticRenderFns } from "./mpractice.vue?vue&type=template&id=adbb00f8&scoped=true&"
import script from "./mpractice.vue?vue&type=script&lang=js&"
export * from "./mpractice.vue?vue&type=script&lang=js&"
import style0 from "./mpractice.vue?vue&type=style&index=0&id=adbb00f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adbb00f8",
  null
  
)

export default component.exports